/** A sidebar row that is a real link (middle click and copy-link work) and navigates in place. */
import { Icon, type IconName } from '@codex/ui';
import type { ReactNode } from 'react';
import { useGoTo } from './open-doc.js';

export function NavLink({
  href,
  icon,
  glyph,
  trailing,
  active,
  testId,
  children,
}: {
  href: string;
  icon?: IconName;
  /** A leading node in place of an icon (a type glyph). */
  glyph?: ReactNode;
  trailing?: ReactNode;
  active?: boolean;
  testId?: string;
  children: ReactNode;
}) {
  const goTo = useGoTo();
  return (
    <a
      className="cx-nav-row cx-shell-link"
      href={href}
      aria-current={active ? 'page' : undefined}
      data-active={active ? '' : undefined}
      data-testid={testId}
      onClick={(event) => goTo(href, event)}
    >
      {glyph ??
        (icon ? <Icon name={icon} /> : <span className="cx-nav-row__spacer" aria-hidden="true" />)}
      <span className="cx-nav-row__label">{children}</span>
      {trailing}
    </a>
  );
}
